
{
  "title": "提交新列表",
  "description": "創建新的服務列表以吸引客戶",
  "alerts": {
    "reviewRequired": "您的列表將在上線前進行審核。"
  },
  "languageNote": "注意：所有列表應使用英文或繁體中文，以便香港用戶更好地查看。"
}
